import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { dashboardService } from '_services';
import { ActionNames, Errors } from '_constants'

export const dashboardActions = {
    load: () => (dispatch) => {
        dispatch(dashboardActions.loadSchedule(new Date()));
        dispatch(dashboardActions.loadTodaysSchedule());
        dispatch(dashboardActions.loadOutstandingNotes());
    },

    loadInitalSchedule: (date) => dispatch => {
        dispatch(dashboardActions.loadScheduleRequest({ date }));
        dispatch(dashboardActions.loadUserPreferences());
        dashboardService.loadSchedule(date)
            .then(
                response => {
                    dispatch(dashboardActions.loadScheduleSuccess({ date, response }))
                    dispatch(dashboardActions.loadTodaysScheduleSuccess({ response }))
                }
                ,
                error => {
                    dispatch(dashboardActions.loadScheduleFailure({ date, error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_SCHEDULE_FAILURE));
                }
            );
    },

    loadUserPreferences: () => dispatch => {
        dispatch(dashboardActions.loadUserPreferencesRequest());
        dashboardService.getUserPreferences()
            .then(
                response => { dispatch(dashboardActions.loadUserPreferencesSuccess({ response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadUserPreferencesFailure({ error }));
                    dispatch(alertActions.error(Errors.USER_PREFERENCES_FAILURE));
                }
            );
    },
    loadUserPreferencesRequest: createAction(ActionNames.USER_PREFERENCES_REQUEST),
    loadUserPreferencesSuccess: createAction(ActionNames.USER_PREFERENCES_SUCCESS),
    loadUserPreferencesFailure: createAction(ActionNames.USER_PREFERENCES_FAILURE),

    saveUserPreferences: (evalStatus) => (dispatch) => {
        dispatch(dashboardActions.saveUserPreferencesRequest({ evalStatus }));

        dashboardService.saveUserPreferences(evalStatus)
            .then(
                () => {
                    dispatch(dashboardActions.saveUserPreferencesSuccess(evalStatus));
                }
                ,
                error => {
                    dispatch(dashboardActions.saveUserPreferencesFailure({ error: error }));
                    dispatch(dashboardActions.error(Errors.SAVE_USER_PREFERENCES_FAILURE));
                }
            );
    },
    saveUserPreferencesRequest: createAction(ActionNames.SAVE_USER_PREFERENCES_REQUEST),
    saveUserPreferencesSuccess: createAction(ActionNames.SAVE_USER_PREFERENCES_SUCCESS),
    saveUserPreferencesFailure: createAction(ActionNames.SAVE_USER_PREFERENCES_FAILURE),

    loadSchedule: (date) => dispatch => {
        dispatch(dashboardActions.loadScheduleRequest({ date }));
        dashboardService.loadSchedule(date)
            .then(
                response => { dispatch(dashboardActions.loadScheduleSuccess({ date, response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadScheduleFailure({ date, error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_SCHEDULE_FAILURE));
                }
            );
    },
    loadScheduleQuiet: (date) => dispatch => {
        dashboardService.loadSchedule(date)
            .then(
                response => { dispatch(dashboardActions.loadScheduleSuccess({ date, response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadScheduleFailure({ date, error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_SCHEDULE_FAILURE));
                }
            );
    },
    loadScheduleRequest: createAction(ActionNames.DASHBOARD_LOAD_SCHEDULE_REQUEST),
    loadScheduleSuccess: createAction(ActionNames.DASHBOARD_LOAD_SCHEDULE_SUCCESS),
    loadScheduleFailure: createAction(ActionNames.DASHBOARD_LOAD_SCHEDULE_FAILURE),

    showHideCxNs: () => dispatch => {
        dispatch(dashboardActions.flipShowCxNs())
    },
    flipShowCxNs: createAction(ActionNames.FLIP_SHOW_CX_NS),

    showHideUnavailable: () => dispatch => {
        dispatch(dashboardActions.flipShowUnavailable())
    },
    flipShowUnavailable: createAction(ActionNames.FLIP_SHOW_UNAVAILABLE),

    loadTodaysSchedule: () => dispatch => {
        dispatch(dashboardActions.loadTodaysScheduleRequest());
        dashboardService.loadSchedule(new Date())
            .then(
                response => { dispatch(dashboardActions.loadTodaysScheduleSuccess({ response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadTodaysScheduleFailure({ error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_TODAYS_SCHEDULE_FAILURE));
                }
            );
    },
    loadTodaysScheduleQuiet: () => dispatch => {
        dashboardService.loadSchedule(new Date())
            .then(
                response => { dispatch(dashboardActions.loadTodaysScheduleSuccess({ response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadTodaysScheduleFailure({ error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_TODAYS_SCHEDULE_FAILURE));
                }
            );
    },
    loadTodaysScheduleRequest: createAction(ActionNames.DASHBOARD_LOAD_TODAYS_SCHEDULE_REQUEST),
    loadTodaysScheduleSuccess: createAction(ActionNames.DASHBOARD_LOAD_TODAYS_SCHEDULE_SUCCESS),
    loadTodaysScheduleFailure: createAction(ActionNames.DASHBOARD_LOAD_TODAYS_SCHEDULE_FAILURE),


    loadOutstandingNotes: () => dispatch => {
        dispatch(dashboardActions.loadOutstandingNotesRequest());
        dashboardService.loadOutstandingNotes()
            .then(
                response => { dispatch(dashboardActions.loadOutstandingNotesSuccess({ response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadOutstandingNotesFailure({ error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_OUTSTANDING_NOTES_FAILURE));
                }
            );
    },
    loadOutstandingNotesQuiet: () => dispatch => {
        dashboardService.loadOutstandingNotes()
            .then(
                response => { dispatch(dashboardActions.loadOutstandingNotesSuccess({ response })) }
                ,
                error => {
                    dispatch(dashboardActions.loadOutstandingNotesFailure({ error }));
                    dispatch(alertActions.error(Errors.DASHBOARD_LOAD_OUTSTANDING_NOTES_FAILURE));
                }
            );
    },
    loadOutstandingNotesRequest: createAction(ActionNames.DASHBOARD_LOAD_OUTSTANDING_NOTES_REQUEST),
    loadOutstandingNotesSuccess: createAction(ActionNames.DASHBOARD_LOAD_OUTSTANDING_NOTES_SUCCESS),
    loadOutstandingNotesFailure: createAction(ActionNames.DASHBOARD_LOAD_OUTSTANDING_NOTES_FAILURE),
}